import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Checkbox, Input } from 'antd';
import TitleValue from '../cmOverview/tabs/seeker/TitleValue';
import Button from '../../NewComponent/Button/Button';
import { bindActionCreators } from 'redux';
import {Actions} from '../../Action/index';
import { updateAdminGroupInfo } from '../../API/api';
import { toast } from "react-toastify";

const containerStyles = {
  display: 'flex',
  justifyContent: 'center',
  gap: '24px',
  padding: '16px',
};

const cardStyle = {
  flex: 1,
  border: '1px solid #EAECF0',
  boxShadow: '0px 4px 16px 0px #1018280F',
  borderRadius: '12px',
  padding: '12px',
};

const tableTitle = {
  fontSize: '18px',
  color: '#2A364A',
  fontWeight: '600',
  textAlign: 'center',
  marginBottom: '12px',
};

const columns = [
  {
    title: TitleValue('Type'),
    dataIndex: 'name',
    key: 'name',
    width: '70%',
    render: (text) => (
      <span style={{ fontSize: '13px', color: '#2A364A', fontWeight: '500' }}>{text}</span>
    ),
  },
  {
    title: TitleValue('Available'),
    dataIndex: 'checked',
    key: 'checked',
    width: '30%',
    render: (checked) => <Checkbox checked={checked} disabled />,
  },
];
const errorToast = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };
function AgenticSettingComponent() {
  const adminSettingReducer = useSelector((state) => state?.adminSettings);
  const userState = useSelector((state) => state?.user);
  const agenticSource = adminSettingReducer?.agenticSource ?? { Internal: [], External: [] };
  const internalData = agenticSource.Internal ?? [];
  const externalData = agenticSource.External ?? [];
  const dispatch = useDispatch();
  const { groupInfoBriefCountChanged } = bindActionCreators(Actions, dispatch);
const onChangeBriefCount=(e)=>{
  groupInfoBriefCountChanged(parseInt(e.target.value));
}
const onClickBriefCount=()=>{
  let payload = adminSettingReducer.groupInfoData;
  payload[0].briefThreshold = userState.briefThreshold;
  updateAdminGroupInfo(payload).then(res=>{
    toast.success(errorToast(res.data.message), {
            position: toast.POSITION.TOP_RIGHT,
          });
  })
}
  return (
    <div >
      {/* Internal Table */}
      <div style={containerStyles}>
        <div style={cardStyle}>
        <div style={tableTitle}>Internal</div>
        <Table
          columns={columns}
          dataSource={internalData.map((item, index) => ({ key: index, ...item }))}
          pagination={false}
          rowKey="name"
          tableLayout="fixed"
        />
      </div>

      {/* External Table */}
      <div style={cardStyle}>
        <div style={tableTitle}>External</div>
        <Table
          columns={columns}
          dataSource={externalData.map((item, index) => ({ key: index, ...item }))}
          pagination={false}
          rowKey="name"
          tableLayout="fixed"
        />
      </div>
      </div>
      <div style={{...cardStyle,marginInline:'15px'}}>
        <div style={{fontSize:'15px'}} className='mb-2'>
          Agentic brief Count Records (Maximum agentic brief triggered in a week)
        </div>
        <div>
          <span style={{fontSize:'14px'}}>Count: <Input min={1} onKeyDown={(e) => e.preventDefault()} onChange={(e)=>onChangeBriefCount(e)} size='large' type="number" style={{width:'70px'}} value={userState.briefThreshold} defaultValue={userState.briefThreshold}  /></span>&nbsp;<Button text={'Update'} onClickFunc={onClickBriefCount} type={'primary'}/>
        </div>
      </div>
    </div>
  );
}

export default AgenticSettingComponent;
